module.exports = __webpack_public_path__ + "img/1_03.1a0302c8.jpg";